import { AxiosInstance } from "axios";
import { ApiRouteHelpers as Helpers } from "../../../root/apiRoutes";
import {
  CreatePrivacyCenterNoticeSectionBatchRequest,
  PrivacyCenterNoticeSectionDto,
  UpdatePrivacyCenterNoticeSectionRequest,
} from "../dto/PrivacyCenterDto";

import {
  OrganizationPublicId,
  PrivacyCenterNoticePublicId,
  PrivacyCenterPublicId,
  UUIDString,
} from "../Types";

export class PrivacyCenterNoticeSectionController {
  constructor(private axios: AxiosInstance) {}

  public getSections = async (
    organizationId: OrganizationPublicId,
    privacyCenterId: PrivacyCenterPublicId,
    noticeId: PrivacyCenterNoticePublicId,
  ) => {
    const url = Helpers.organization.privacyCenter.notices.sections.root(
      organizationId,
      privacyCenterId,
      noticeId,
    );
    const response = await this.axios.get<PrivacyCenterNoticeSectionDto[]>(url);
    return response.data;
  };

  public getSection = async (
    organizationId: OrganizationPublicId,
    privacyCenterId: PrivacyCenterPublicId,
    noticeId: PrivacyCenterNoticePublicId,
    sectionId: UUIDString,
  ) => {
    const url = Helpers.organization.privacyCenter.notices.sections.specific(
      organizationId,
      privacyCenterId,
      noticeId,
      sectionId,
    );
    const response = await this.axios.get<PrivacyCenterNoticeSectionDto>(url);
    return response.data;
  };

  public createSection = async (
    organizationId: OrganizationPublicId,
    privacyCenterId: PrivacyCenterPublicId,
    noticeId: PrivacyCenterNoticePublicId,
    createSectionBody: CreatePrivacyCenterNoticeSectionBatchRequest,
  ) => {
    const url = Helpers.organization.privacyCenter.notices.sections.root(
      organizationId,
      privacyCenterId,
      noticeId,
    );
    const response = await this.axios.post<PrivacyCenterNoticeSectionDto>(url, createSectionBody);
    return response.data;
  };

  public updateSection = async (
    organizationId: OrganizationPublicId,
    privacyCenterId: PrivacyCenterPublicId,
    noticeId: PrivacyCenterNoticePublicId,
    sectionId: UUIDString,
    updateSectionBody: UpdatePrivacyCenterNoticeSectionRequest,
  ) => {
    const url = Helpers.organization.privacyCenter.notices.sections.specific(
      organizationId,
      privacyCenterId,
      noticeId,
      sectionId,
    );
    const response = await this.axios.patch<PrivacyCenterNoticeSectionDto>(url, updateSectionBody);
    return response.data;
  };

  public deleteSection = async (
    organizationId: OrganizationPublicId,
    privacyCenterId: PrivacyCenterPublicId,
    noticeId: PrivacyCenterNoticePublicId,
    sectionId: UUIDString,
  ) => {
    const url = Helpers.organization.privacyCenter.notices.sections.specific(
      organizationId,
      privacyCenterId,
      noticeId,
      sectionId,
    );
    const response = await this.axios.delete<PrivacyCenterNoticeSectionDto>(url);
    return response.data;
  };
}
